module.exports = __webpack_public_path__ + "media/images/massage/samia@2x-94c4eeb6750b9243788a04c7e474b474.jpg";